export const MILESTONE_STATUS = {
  ASSIGNED: 0,
  ONGOING: 1,
  COMPLETED: 2,
};

export const milestoneStatusToText = ['Assigned', 'Ongoing', 'Completed'];
